<template>

<div class="col backgroundForm">
    <h3 class="col" align="center">Reimpresion de Descargos por Ingresos </h3>
    <div class="form-row">
        <div class="form-group col offset-md-3 col-md-6">
            <label for="captain_download" class="badge badge-info">CAPITANIA</label>
            <transition name="fade" mode="out-in">
            <select v-if="dRolUser" name="captain_download" class="form-control" id="captain_download" v-model="port_select">
                <option v-for="port in port_local" :value="port" :key="port.id">{{ port.name_port }}</option>
            </select>
            <div v-else class="alert alert-success">
                {{ cSessionUser.name_port }}
            </div>
            </transition>
        </div>
    </div>

    <div class="form-row">
        <div class="form-group col col-md-4 offset-md-2">
            <label for="date_init_discharge" class="badge badge-info">DEL:</label>         
            <input type="date" class="form-control" id="date_init_discharge" name="date_init_discharge" v-model="date_init" placeholder="DD/MM/YYYY" autocomplete="off">
        </div>
        <div class="form-group col col-md-4">
            <label for="date_end_discharge" class="badge badge-info">AL:</label>         
            <input type="date" class="form-control" id="date_end_discharge" name="date_end_discharge" v-model="date_end" placeholder="DD/MM/YYYY" autocomplete="off">
        </div>
    </div>
    <button class="btn btn-outline-primary col col-md-4 offset-md-4" @click="mCallDischarges"><font-awesome-icon icon="list" /> Listar</button>
    <br><br>
    <transition name="fade">
        <div v-if="docs_discharge.length > 0">            
            <div class="table-responsive">
                <table class="table">
                    <thead class="thead-dark">
                        <tr>
                            <th>#</th>
                            <th scoped="col">Tramite</th>
                            <th scoped="col">Numero Tramite</th>
                            <th scoped="col">Importe</th>
                            <th scoped="col">Imprimir</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ddis, index) in docs_discharge" :key="ddis.id">
                            <td>{{ index+1 }}</td>
                            <td>{{ ddis.module }}</td>
                            <td>{{ ddis.lote }}/{{ ddis.year }} ( {{ ddis.date }} )</td>
                            <td>{{ ddis.import }}</td>
                            <td align="center">
                                <button class="btn btn-outline-info" @click="mModalShow(ddis.id)"><font-awesome-icon icon="print" /></button>  
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </transition>
    
    <modal-report :id-modal-report="modal_report" :title="modal_rep_title" :content="modal_rep_content" :url-r="url_report" :id-report="id_reporte" ></modal-report>
</div>
  
</template>

<script>

import axios from 'axios';
import Vue from 'vue';

import modalReport from '../modal/modalReport';

export default {
    name:'reprint-discharge',
    data(){
        return{
            date_init:null,
            date_end:null,
            port_local:[],
            dRolUser:false,
            port_select:null,
            detail_oper:[],
            docs_discharge:[],
            modal_report:'reprintDischarge',
            title:'Reimpresion de Descargo',
            modal_rep_content:'Reimpresion de Descargo',
            url_report:'pdfDischarge',
            id_reporte:0,
            modal_rep_title:'Reporte'
        }        
    },
    mounted(){
        this.getToday(),
        this.chargeInit()
    },
    methods:{
        async chargeInit(){
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);        
            let det_op=await axios.get(`dtsOperations?api_token=${Vue.auth.getToken()}`);

            this.port_local=ports.data;
            this.dRolUser= this.cSessionUser.role !== 4 ? true:false;
            
            this.detail_oper=det_op.data;
        },
        async mCallDischarges(){
            let auxPort;
            auxPort=this.dRolUser ? this.port_select.id : this.cSessionUser.portId;
            if(auxPort != null){
                // aqui llamar todos los descargos enviados para su reimpresion desde sistema
                let dsend=await axios.get(`getDischarges/${auxPort}/${this.date_init}/${this.date_end}?api_token=${Vue.auth.getToken()}`);
                console.log(dsend);
                this.docs_discharge=[];
                let aux_dts = dsend.data;
                aux_dts.forEach(el => {
                    let idtx=this.detail_oper.findIndex(bi => bi.id === el.module);
                    let aux_array={
                        id:el.id_t_master,
                        import:el.import_gral,
                        lote:el.n_lote,
                        year:el.n_year,
                        module:this.detail_oper[idtx].description,
                        date:el.date_download
                    }
                    this.docs_discharge.push(aux_array);
                });
                
            }else{
                toastr.warning(`Seleccione una capitania`, `Advertencia`);
            }
        },
        getToday(){
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
            this.date_init=date_aux;
            this.date_end=date_aux;            
        },
        mModalShow(id){
            // aqui configurar todo la url e id que iran
            this.id_reporte=id;
            $('#'+this.modal_report).modal('show');
        }
    },
    computed:{
        cSessionUser(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        'modal-report':modalReport
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/finanzas/ReprintDischarge.vue